import { Skeleton } from '@heidi/design-system/skeleton';

const SessionSkeletonRow = () => {
  return (
    <div className="flex w-full flex-row items-center justify-center gap-2 px-1.5 py-1">
      <Skeleton className="size-5 rounded-full" />
      <div className="flex grow flex-col gap-1">
        <Skeleton className="h-2 w-full rounded-sm" />
        <Skeleton className="h-2 w-1/2 rounded-sm" />
      </div>
    </div>
  );
};

const SessionSkeletonGroup = () => {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-0.5">
      <Skeleton className="h-2 w-1/3 self-start rounded-sm" />
      <SessionSkeletonRow />
      <SessionSkeletonRow />
    </div>
  );
};

export const UpcomingSessionsListLoader = () => {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-2 pt-2">
      <SessionSkeletonGroup />
      <SessionSkeletonGroup />
      <SessionSkeletonGroup />
    </div>
  );
};
